import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * `?find=<text>` on any page (search results use it): once the page has drawn its list, the
 * first row showing that text is scrolled into view and marked for a few seconds. Lists
 * load after the page does, so it looks for up to six seconds. Nothing is filtered: the
 * whole list is still there.
 */
export default function FindOnPage() {
  const { pathname, search } = useLocation()
  useEffect(() => {
    const want = new URLSearchParams(search).get('find')?.trim().toLowerCase()
    if (!want) return
    let tries = 0, marked: HTMLElement | null = null
    const look = () => {
      const main = document.querySelector('main')
      if (!main) return false
      const walker = document.createTreeWalker(main, NodeFilter.SHOW_TEXT)
      for (let n = walker.nextNode(); n; n = walker.nextNode()) {
        if (!(n.textContent || '').toLowerCase().includes(want)) continue
        const el = (n.parentElement?.closest('tr, li, article, [role="row"], .rounded-xl, .rounded-2xl, .rounded-lg') as HTMLElement | null) ?? n.parentElement
        if (!el || el.closest('input, textarea, select')) continue
        el.scrollIntoView({ block: 'center', behavior: 'smooth' })
        el.classList.add('lq-found'); marked = el
        setTimeout(() => el.classList.remove('lq-found'), 3500)
        return true
      }
      return false
    }
    const t = setInterval(() => { if (look() || ++tries > 24) clearInterval(t) }, 250)
    return () => { clearInterval(t); marked?.classList.remove('lq-found') }
  }, [pathname, search])
  return null
}
